<template>
  <ReviewDisplay
    :id
    :average-rate
    :comment
    :country-code
    :customer
    :display-product-link
    :display-seller
    :language-code
    :product
    :purchase-date="product.purchasedAt"
    :review-date="createdAt"
    :sales-order-item
    :seller
    :track-review-impression="true"
    :trackingData="{
      onClick: clickTrackingData,
      onImpression: impressionTrackingData,
    }"
    :translated-comment
    :vote-count
  >
    <PhotosSlider
      data-test="photos-slider"
      v-bind="props"
      :trackingData="clickTrackingData"
    />
  </ReviewDisplay>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import ReviewDisplay from '@backmarket/nuxt-layer-reviews/review-display/ReviewDisplay.vue'

import { PRODUCT } from '~/scopes/product/route-names'

import { ROUTES } from '../../../route-names'
import type { DisplayedReview } from '../../models/reviews'
import PhotosSlider from '../PhotosSlider/PhotosSlider.vue'

const props = defineProps<
  DisplayedReview & {
    position: number
  }
>()

const route = useRoute()

const displaySeller = route.name !== ROUTES.PAGES.MERCHANT
const displayProductLink = route.name !== PRODUCT.HOME

const impressionTrackingData = {
  reviewPosition: props.position,
  pageType: route.name as string,
  reviewPhotos: Boolean(props.attachments?.length),
  photosReviewsDisplayed: (props.attachments || []).length,
  reviewComment: Boolean(props.comment),
  reviewVoteCount: props.voteCount,
  zone: 'reviews_list',
}

const clickTrackingData = {
  zone: `review_position_${props.position}`,
  page_type: route.name as string,
}
</script>
